import { LinearProgress, Typography } from '@mui/material';
import TracksList from 'components/playlist/TracksList';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSharedPlaylistData } from 'services/api/playlists';
import { updateFBUserPlaylistsLocal } from 'store/data/user/actions';
import { ApplicationState, UserPlaylist, UserPlaylistTracks } from 'types';
import Page from './Page';

interface PlaylistPageProps {
	playlists: { [id: string]: UserPlaylist };
	updateFBUserPlaylistsLocal: (playlists: { [id: string]: UserPlaylist }) => void;
}

function PlaylistPage(props: PlaylistPageProps) {
	let { href } = useParams();
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState<string | null>(null);
	const [playlistData, setPlaylistData] = React.useState<UserPlaylist | undefined>(undefined);

	href = href || '';

	React.useEffect(() => {
		let isSharedPlaylist = href!.startsWith('shared-');
		let sharedPlaylistData = props.playlists[href!];
		if (isSharedPlaylist) {
			setLoading(true);
			setError(null);

			const parts = href!.split('-');
			const originalUserId = parts[1];
			const originalPlaylistId = parts[2];

			let playlist = sharedPlaylistData
				? { ...sharedPlaylistData, ownerUserId: originalUserId }
				: ({
						id: href,
						ownerUserId: originalUserId,
						title: 'Loading...', // Will be updated when actual data is fetched
						tracks: {},
						playlistId: originalPlaylistId, // Store original playlist ID
						deleted: false,
				  } as UserPlaylist);

			fetchSharedPlaylistData(playlist)
				.then((data) => {
					if (data) {
						setPlaylistData(data);
						// let playlists = { ...props.playlists };
						// playlists[data.id] = data;
						// props.updateFBUserPlaylistsLocal(playlists);
					} else {
						setError('This shared playlist is no longer available');
					}
				})
				.catch((err) => {
					console.error('Error fetching shared playlist:', err);
					setError('Failed to load shared playlist');
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [href]);

	return (
		<Page title="Playlist" includeBottomNavigation topControlHeight={64} dark>
			{loading ? (
				<LinearProgress />
			) : error ? (
				<Typography color="error" style={{ padding: 16 }}>
					{error}
				</Typography>
			) : (
				<TracksList playlistId={href} playlist={playlistData} />
			)}
		</Page>
	);
}

function mapStateToProps(state: ApplicationState) {
	return {
		playlists: state.userState.userStore.subColl?.playlists || {},
	};
}

function mapDispatchToProps(dispatch) {
	return {
		updateFBUserPlaylistsLocal: (playlists) => {
			dispatch(updateFBUserPlaylistsLocal(playlists));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistPage);
